import { useEffect, useState } from "react";
import { Product } from "../api/schemas";
import { apiVersion } from "../consts/api";
import { RequestError } from "../utils/error";
import { getNumber } from "../utils/number";

export function useProduct() {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<RequestError | null>(null);
  const [product, setProduct] = useState<Product>();

  useEffect(() => {
    (async () => {
      const product = (await getProduct(getNumber())) as Product;
      setProduct(product);
      setIsLoading(false);
    })().catch((error: RequestError) => {
      setError(error);
      setIsLoading(false);
    });
  }, []);

  return {
    isLoading,
    error,
    product,
  };
}

async function getProduct(handle: string) {
  const method = "GET";
  const response = await fetch(
    `${import.meta.env.VITE_IDEAL_API_FQDN}/${apiVersion}/products/${handle}`,
    {
      method,
    },
  );

  const text = await response.text();

  if (!response.ok) {
    throw new RequestError(method, `products/${handle}`, response.status);
  }

  let json;
  try {
    json = JSON.parse(text) as unknown;
  } catch {
    json = {};
  }

  return json;
}
